import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getClientes = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/clientespro?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getClientesEstado = async (estado) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/clientespro/estado?empresa=${userInfo.empresa}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getClientesRut = async (rut) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/clientespro/rut?empresa=${userInfo.empresa}&rutCliPro=${rut}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getClientesRutOnBoard = async (rut) => {
    try {      
      const {data}  = await Axios.get(
        `/clientespro/rut/onboard?empresa=67fb199c799c1b69ec40fa38&rutCliPro=${rut}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

    export const getClientesEmailOnBoard = async (email) => {
    try {      
      const {data}  = await Axios.get(
        `/clientespro/email/onboard?empresa=67fb199c799c1b69ec40fa38&email=${email}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };



  export const onBoardCliente = async (clienteData) => {
    try {
        
        const {data}  = await Axios.post(
            '/clientespro/onboard', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const crearCliente = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/clientespro', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCliente = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/clientespro/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCliente = (Id) => Axios.delete(`/clientespro/${Id}`);
